// client/src/core/App.js
import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import HomePage from '../components/pages/home/HomePage.js';
import ServicesPage from '../components/pages/services/ServicesPage.js';
import ProductsPage from '../components/pages/products/ProductsPage.js';
import BlogPage from '../components/pages/blog/BlogPage.js';
import AboutPage from '../components/pages/about/AboutPage.js';
import ContactPage from '../components/pages/contact/ContactPage.js';
import LoginPage from '../components/login/LoginPage.js';
import ForgotPasswordPage from '../components/login/ForgotPasswordPage.js';
import RegisterPage from '../components/register/RegisterPage.js';
import PrivacyPolicyPage from '../components/agreements/PrivacyPolicyPage.js';
import CookiesPolicyPage from '../components/agreements/CookiesPolicyPage.js';
import UserAgreementPage from '../components/agreements/UserAgreementPage.js';
import ActivateAccount from '../components/register/ActivateAccount.js';
import NotFound from '../components/common/NotFound.js';
import Dashboard from '../components/dashboard/Dashboard.js';
import PrivateRoute from '../components/dashboard/PrivateRoute.js';
import { AuthProvider } from '../context/AuthContext.js';
import { useTranslation } from 'react-i18next';
import ResetPasswordPage from '../components/login/ResetPasswordPage.js';
import AndroidAppPage from '../components/pages/AndroidAppPage.js'; // Import
import Layout from '../components/common/Layout.js'; // Import Layout
import { isAndroid } from 'react-device-detect';
import VerifySecondaryEmailPage from '../components/verification/VerifySecondaryEmailPage';
import VerifyEmergencyEmailPage from '../components/verification/VerifyEmergencyEmailPage';



import 'normalize.css';
import './App.css';

function App() {
    const { i18n } = useTranslation();

    useEffect(() => {
        document.documentElement.dir = i18n.language === 'ar' ? 'rtl' : 'ltr';
    }, [i18n.language]);

    useEffect(() => {
        const handleBeforeUnload = () => {
            sessionStorage.removeItem('userId');
            sessionStorage.removeItem('expiry');
        };

        window.addEventListener('beforeunload', handleBeforeUnload);
        window.addEventListener('unload', handleBeforeUnload); //For better compability with older browsers.

        return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload);
            window.removeEventListener('unload', handleBeforeUnload);
        };
    }, []); // Empty dependency array: runs only on mount and unmount

    const android = isAndroid;

    return (
        <AuthProvider>
            <BrowserRouter>
                {android ? (
                    <Routes>
                        <Route path="*" element={<Navigate to="/android-app-recommendation" replace />} />
                        <Route path="/android-app-recommendation" element={<AndroidAppPage />} />
                    </Routes>

                ) : (
                    <Routes>
                        <Route path="/" element={<Layout><HomePage /></Layout>} />
                        <Route path="/services" element={<Layout><ServicesPage /></Layout>} />
                        <Route path="/products" element={<Layout><ProductsPage /></Layout>} />
                        <Route path="/blog" element={<Layout><BlogPage /></Layout>} />
                        <Route path="/about" element={<Layout><AboutPage /></Layout>} />
                        <Route path="/contact" element={<Layout><ContactPage /></Layout>} />
                        <Route path="/login" element={<Layout><LoginPage /></Layout>} />
                        <Route path="/forgot-password" element={<Layout><ForgotPasswordPage /></Layout>} />
                        <Route path="/register" element={<Layout><RegisterPage /></Layout>} />
                        <Route path="/privacy-policy" element={<Layout><PrivacyPolicyPage /></Layout>} />
                        <Route path="/cookies-policy" element={<Layout><CookiesPolicyPage /></Layout>} />
                        <Route path="/user-agreement" element={<Layout><UserAgreementPage /></Layout>} />
                        <Route path="/activate/:userId" element={<Layout><ActivateAccount /></Layout>} />
                        <Route path="/reset-password/:token" element={<Layout><ResetPasswordPage /></Layout>} />
                        {/* Protected Routes */}
                        <Route
                            path="/dashboard"
                            element={
                                <PrivateRoute>
                                    <Dashboard />
                                </PrivateRoute>
                            }
                        >
                        </Route>
                        <Route
                            path="/verify-secondary-email/:token"
                            element={<Layout><VerifySecondaryEmailPage /></Layout>}
                        />
                        <Route
                            path="/verify-emergency-email/:token"
                            element={<Layout><VerifyEmergencyEmailPage /></Layout>}
                        />
                        <Route path="*" element={<Layout><NotFound /></Layout>} />
                    </Routes>
                )}
            </BrowserRouter>
        </AuthProvider>
    );
}

export default App;